import * as React from 'react';

export function useEventProxy() {
  const proxy = React.useRef(new EventTarget());

  return proxy.current;
}
